import { Card } from 'antd';
import { useLanguage } from '../../utils/LanguageContext';
import translations from './AccountSettings.lang.json';
import { useAuth } from '../../utils/AuthContext';
import { useRefreshingAsync } from '../common/commonHooks';

const InvestmentAccountDetails = () => {
  const { lang } = useLanguage(translations);
  const { user, api } = useAuth();

  const investmentAccounts = useRefreshingAsync(api.getInvestmentAccounts);

  return (
    <>
      <Card title={lang('accounts')}>
        {investmentAccounts?.length > 0 ? (
          investmentAccounts.map((account) => (
            <div key={account._id}>
              <p>
                {lang('accountType')}: {account.accountType}
              </p>
            </div>
          ))
        ) : (
          <p>{lang('noAccountRecords')}</p>
        )}
        {user.disclosureQuestions && (
          <div>
            <p>{/* {lang('Connected Bank Account for Transfers')}: {user.plaid.accountName} */}</p>
            <br />
            <h3>{lang('disclosureResponses')}</h3>
            <p>
              {lang('brokerQuestion')}: {user.disclosureQuestions.isAffiliatedExchangeOrFinra}
              <br />
              {lang('directorQuestion')}: {user.disclosureQuestions.isControlPerson}
              <br />
              {lang('politcalQuestion')}: {user.disclosureQuestions.isPoliticallyExposed}
            </p>
          </div>
        )}
      </Card>
    </>
  );
};

export default InvestmentAccountDetails;
